import React, { Component } from 'react';
import './style.scss';

class OptionRadioCheck extends Component {
  check = (value) => {
    if (value === 'その他（自由記入）')
      this.props.input.onChange('');
    this.props.input.onChange(value);
  }
  render() {
    const value = this.props.input.value;
    const { data = [] } = this.props;
    return (
      <div id="reason-ex-container">
        {
          data.map((elem, index) => {
            return (
              <div key={index} className="reason-ex-check">
                <img alt='' onClick={() => this.check(elem)} src={value === elem ? '/images/checked.svg' : '/images/uncheck.svg'} />
                <div className='option-text'>{elem}</div>
              </div>
            );
          })
        }
      </div>
    );
  }
}

export default OptionRadioCheck;